<template>
  <basic-container>
    <el-form ref="searchFormRef" :model="query" label-width="100px" margin-top="0" :rules="rules" v-if="searchBoxFlag">
      <el-row>
        <el-col :span="6">
          <!-- <el-form-item label="速记码" prop="shortCode">
            <el-input
              v-model="query.shortCode"
              @input="propertyFilter()"
              placeholder="速记码"
            ></el-input>
          </el-form-item> -->

          <el-form-item label="小区分组" prop="communityGroup">

            <el-select style="width: 100%" v-model="query.communityGroup" @change="communityGroupChangeHandler">
              <el-option
                v-for="item in communityGroupList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="小区名称" prop="propertyId">


                <avue-input-tree
                style="width: 100%;"
                    node-key="id"
                    :props="defaultProps"
                    default-expand-all
                    v-model="query.propertyId"
                    placeholder="请选择小区"
                    type="select"
                    @change="communityIdChange"
                    :dic="allPropertyListCopy"
                >
                </avue-input-tree>
            <!-- <el-select v-model="query.propertyId" placeholder="请选择小区" style="width: 100%;">
              <el-option
                v-for="item in allPropertyListCopy"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="房产类型" prop="useType">
            <el-select v-model="query.useType" placeholder="全部" style="width: 100%;" clearable>
              <el-option
                v-for="item in useTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="细分费项" prop="sortTypeListSearch">
            <el-select v-model="query.sortTypeListSearch" placeholder="全部" style="width: 100%;" multiple="true" clearable>
              <el-option
                v-for="item in useSortTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收费日期" prop="dateRange">
            <!-- <el-date-picker
            @change="daterangeChangeHandler"
              style="width:100%;"
              v-model="dateRange"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker> -->

            <el-date-picker
              style="width:42%;"
              v-model="dateRangeStart"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="dateRangeEnd"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收费周期" prop="dateRange">
            <!-- <el-date-picker
              style="width:100%;"
              v-model="dateRangeCycle"
              type="monthrange"
              value-format="yyyy-MM"
              format="yyyy 年 MM 月"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker> -->
            <el-date-picker
              style="width:42%;"
              v-model="dateRangeCycleStart"
              type="month"
              value-format="yyyy-MM"
              format="yyyy 年 MM 月"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="dateRangeCycleEnd"
              type="month"
              value-format="yyyy-MM"
              format="yyyy 年 MM 月"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="支付方式" prop="payType">
            <el-select v-model="query.payType" placeholder="全部" style="width: 100%;" clearable>
              <el-option
                v-for="item in allPayTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="缴费人" prop="householdName">
            <el-input v-model="query.householdName" placeholder="缴费人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="缴费来源" prop="payCost">
            <el-select v-model="query.payCost" placeholder="全部" style="width: 100%" clearable>
              <el-option
                v-for="item in allPayCostList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="票据号" prop="invoiceNo">
            <el-input v-model="query.invoiceNo" placeholder="票据号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="应缴金额" prop="invoiceNo">
            <el-input v-model="shouldAmountSum" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="实缴金额" prop="invoiceNo">
            <el-input v-model="payAmountSum" disabled ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="查看" prop="looking">
            <el-radio v-model="query.radio" label="2">汇总</el-radio>
            <el-radio v-model="query.radio" label="1">明细</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item style="text-align: right;">
            <el-button
            size="small"
              type="primary"
              native-type="submit"
              icon="el-icon-search"
              @click.prevent="submitSearchForm"
              >搜索</el-button
            >
            <el-button type="white"
            size="small" @click="searchReset" icon="el-icon-delete">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>




        <!-- <el-col :span="3">
          <el-form-item label="应缴金额" prop="shouldAmountSum">
            <el-input :value="shouldAmountSum" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item label="实收金额" prop="payAmountSum">
            <el-input :value="payAmountSum" :disabled="true"> </el-input>
          </el-form-item>
        </el-col> -->

      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="exportExcel()"
          >导 出
        </el-button>
          <!-- <span>{{"应缴金额:"+shouldAmountSum+"元 "+"实收金额:"+payAmountSum+"元 "}}</span> -->
      </template>

            <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
                :refOption="$refs.crud"
                ></searchFromShow>

            </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getExcel, getList, remove, update,getSortTypeByCommunityId,feeSortListByCommunityId ,getUseTypeListByCommunityId} from '@/api/v4ward/paylist/feepaylist';
import { mapGetters } from 'vuex';
import { getOptionNode } from '../../../api/v4ward/property/baseproperty';
import searchFromShow from '@/components/search-form-show/index'
import { getDictionary, getCommunityGroupList } from '../../../api/common';
    import _ from 'lodash';

export default {
  components: { searchFromShow },
  watch:{
    "query.propertyId"(){
      this.query.useType=""
      this.query.sortTypeListStr="";
      this.query.sortTypeListSearch="";
      if(this.query.propertyId==""){
        this.useTypeList =[]
        this.useSortTypeList=[]
      }else{
        getUseTypeListByCommunityId({communityId:this.query.propertyId}).then(res=>{
          this.useTypeList =res.data
        })

        getSortTypeByCommunityId({communityId:this.query.propertyId}).then(res=>{
          this.useSortTypeList =res.data
        })
      }
    }
  },
  data() {
    return {
      allPayCostList:[],
      useSortTypeList:[],
      useTypeList:[],
      dateRangeCycleStart:'',
      dateRangeCycleEnd:'',
      dateRangeStart:'',
      dateRangeEnd:'',
       searchBoxFlag:true,
        defaultProps:{
            children: 'children',
            label: 'title',
        value: 'id',
        },
      //如果已经根据速记码查询过了小区信息则为true
      propertyIsQuery: false,
      payAmountSum: '',
      shouldAmountSum: '',
      dateRange: [],
      dateRangeCycle: [],
      allPayTypeList: [],
      allPropertyList: [],
      allPropertyListCopy: [],
      allSortTypeList: [],
      communityGroupList:[],
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      propertyName: '',
      form: {},
      query: {
        // propertyId:'',
        communityGroup:"",
        shortCode: '',
        propertyId: '',
        sortTypeListStr: "",
        sortTypeListSearch: "",
        dateFrom: '',
        dateTo: '',
        householdName: '',
        invoiceNo: '',
        payType: '',
        radio: '2', //1代表明细，2代表汇总,
        payCost:'',
        useType:'',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        excelBtn: false,
        selection: false,
        menu: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '地址',
            prop: 'roomName',
          },
          {
            label: '费项类别',
            prop: 'feeSortName',
          },
          {
            label: '收费周期',
            prop: 'billcycleNo',
          },
          {
            label: '缴费人',
            prop: 'householdName',
          },
          {
            label: '收费时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
          },
          {
            label: '滞纳金',
            prop: 'delayAmount',
          },
          {
            label: '抵扣金额',
            prop: 'accountpayAmount',
          },
          {
            label: '优惠金额',
            prop: 'derateAmount',
          },
          {
            label: '收费金额',
            prop: 'payAmount',
          },
          {
            label: '支付方式',
            prop: 'payType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            dataType: 'number',
          },
          {
            label: '收款人',
            prop: 'cashierName',
          },
          {
            label: '票据号',
            prop: 'invoiceNo',
          },
          {
            label:'支付状态',
            prop: 'payStatus',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            dicData:[
            {

              dictKey:0,
              dictValue:'未支付',
            },
            {

              dictKey:1,
              dictValue:'已支付',
            },
            {

              dictKey:2,
              dictValue:'部分退款',
            },
            {

              dictKey:3,
              dictValue:"全部退款",
            },
            {

              dictKey:9,
              dictValue:'已关闭',
            },
            ]
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basebankchangeinfo_add, false),
        viewBtn: this.vaildData(this.permission.basebankchangeinfo_view, false),
        delBtn: this.vaildData(this.permission.basebankchangeinfo_delete, false),
        editBtn: this.vaildData(this.permission.basebankchangeinfo_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    getDictionary('pay_cost').then((data) => {

        this.allPayCostList = data.data;
      });
    this.initDefaultDateRange();

          let this_ = this;
      getCommunityGroupList().then((res)=>{
        this.communityGroupList = res.data;
        this.query.communityGroup = res.data[0].dictKey;
        this.initPropertyList().then(() => {
          this.initSortTypeList().then(() => {
            this.initPayTypeList();
            console.log('initPropertyList===============>');
              this.query.propertyId = this.allPropertyListCopy[0].id;
              // this.query = _.cloneDeep(this_.query);
            console.log('initPropertyList=======this_.query========>',this_.query);
            this.onLoad();
          });
        });
      });
  },
  mounted(){
    // console.log("avue-crud__right=======>",);
    document.querySelector('.avue-crud__right').children[0].style.float='right'
      this.calcHeight();
  },
  methods: {
    calcHeight(){
      this.searchHeight = this.$refs.searchFormRef .$el.clientHeight
      this.option.height = this.bodyHeight - 340;
    },
    daterangeChangeHandler(val){
      if(val&&val.length>0){
        val
      }
      console.log("daterangeChangeHandler=================>",val);
    },
    communityIdChange(val){
      console.log("communityIdChange=================>",val);
      // this.query.sortType =""
      // feeSortListByCommunityId({communityId:val}).then((res)=>{
      //   this.allSortTypeList = res.data
      //   console.log('****',this.allSortTypeList)
      // })
    },
        communityGroupChangeHandler(val){
          let this_ = this;
          this.allPropertyListCopy = [];
            this.initPropertyList().then(() => {

          this.initSortTypeList().then(() => {
            this.initPayTypeList();
              this.query.propertyId = this.allPropertyListCopy[0].id;
              this.query = _.cloneDeep(this_.query);
            console.log('initPropertyList========this.query.propertyId=======>',this.query.propertyId);

            // this.onLoad();
          });
        });
        },
    //监听速记码变化过滤房产信息
    propertyFilter() {
      let val = this.query.shortCode;
      if (val) {
        //速记码存在,改变小区过滤状态，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList.filter(function (item) {
          return item.shortCode.indexOf(val) > -1;
        });
        this.propertyIsQuery = true;
      } else {
        //val为空时，还原数组,将过滤状态还原，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList;
        this.propertyIsQuery = false;
        this.query.propertyId = '';
      }
      if (this.allPropertyListCopy.length > 0)
        this.query.propertyId = this.allPropertyListCopy[0].id;
      else this.query.propertyId = '';
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {
        shortCode: '',
        propertyId: '',
        sortTypeListStr: "",
        sortTypeListSearch: "",
        dateFrom: '',
        dateTo: '',
        householdName: '',
        invoiceNo: '',
        payType: '',
        radio: '2', //1代表明细，2代表汇总
      };
      this.propertyFilter();
      this.onLoad();
      this.initDefaultDateRange();
      this.query.communityGroup = this.communityGroupList[0].dictKey;
      this.communityGroupChangeHandler();
    },
    searchChange(params, done) {
      console.log('=========searchChange====1=====');
      this.query = params;
      console.log('=========searchChange====2=====');
      this.page.currentPage = 1;
      console.log('=========searchChange====3=====');
      this.onLoad();
      console.log('=========searchChange====4=====');
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    submitSearchForm() {
      let this_ = this;
      this_.searchChange(this_.query);
    },
    onLoad(page) {
      if (this.dateRangeStart&&this.dateRangeEnd) {
        this.query.dateFrom = this.dateRangeStart + ' 00:00:00.000';
        this.query.dateTo = this.dateRangeEnd + ' 23:59:59.999';
      }else if(!this.dateRangeStart&&!this.dateRangeEnd){
        this.query.dateFrom = '';
        this.query.dateTo = '';
      }else{
        this.$message.error('请选择收费日期');
        return;
      }
      if (this.dateRangeCycleStart && this.dateRangeCycleEnd) {
        // this.query.billcycleNoStart = this.dateRangeCycle[0] + ' 00:00:00.000';
        // this.query.billcycleNoEnd = this.dateRangeCycle[1] + ' 23:59:59.999';
        this.query.billcycleNoStart = ((this.dateRangeCycleStart).split('-'))[0]+((this.dateRangeCycleStart).split('-'))[1]
        this.query.billcycleNoEnd = ((this.dateRangeCycleEnd).split('-'))[0]+((this.dateRangeCycleEnd).split('-'))[1]
      }else if(!this.dateRangeCycleStart && !this.dateRangeCycleEnd){
        this.query.billcycleNoStart = '';
        this.query.billcycleNoEnd = '';
      }else{
        this.$message.error('请选择收费周期');
        return;
      }
      if (this.propertyIsQuery && !this.query.propertyId) {
        if (this.allPropertyListCopy.length > 0) {
          this.query.propertyId = this.allPropertyListCopy[0].id;
        } else {
          this.$message.error('未查询到任何小区，请重新输入速记码!');
          return;
        }
      }
      page = page || this.page;
      this.loading = true;
      if(this.query.sortTypeListSearch){
        this.query.sortTypeListStr = this.query.sortTypeListSearch.join(',');
      }
      if (!this.query.propertyId) {
        getOptionNode({}).then((data) => {
          this.query.propertyId = data.data[0].id;
          getList(
            Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
          ).then(({ data }) => {
            this.page.total = data.ipage.total;
            this.data = data.ipage.records;
            this.shouldAmountSum = data.shouldAmountSum;
            this.payAmountSum = data.payAmountSum;
            this.loading = false;
            this.selectionClear();
          });
        });
        return;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.ipage.total;
          this.data = data.ipage.records;
          this.shouldAmountSum = data.shouldAmountSum;
          this.payAmountSum = data.payAmountSum;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    clearProperty() {
      this.propertyName = '';
      this.query.roomId = '';
    },
    initDefaultDateRange() {
      this.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
      this.dateRangeCycle = [];
      // this.dateRangeStart = this.getCurrentMonthFirst();
      // this.dateRangeEnd = this.getCurrentMonthLast();
      this.dateRangeCycleStart = '';
      this.dateRangeCycleEnd = '';
    },
    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    initPropertyList(cb) {
      let this_ = this;
      return getOptionNode({communityGroup:this_.query.communityGroup|| ''}).then((data) => {
        if (this.propertyIsQuery) {
          this.allPropertyList = data.data;
        } else {
          this.allPropertyList = data.data;
          this.allPropertyListCopy = data.data;
        }
        // cb(data.data);
      });
    },

    initSortTypeList: function () {
      return getDictionary('fee_sort').then((data) => {
         this.allSortTypeList = data.data;
      });
    },

    initPayTypeList: function () {
      getDictionary('pay_type').then((data) => {
        this.allPayTypeList = data.data;
      });
    },
    //导出
    exportExcel() {
      this.$confirm('确定导出所有数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if(this.query.sortTypeListSearch){
          this.query.sortTypeListStr = this.query.sortTypeListSearch.join(',');
        }
        getExcel(Object.assign({}, this.query)).then(({ data }) => {
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '地址',
              '费项类别',
              '收费周期',
              '缴费人',
              '收费时间',
              '应收金额',
              '滞纳金',
              '抵扣金额',
              '优惠金额',
              '收费金额',
              '支付方式',
              '收款人',
              '票据号',
              '支付备注',
            ]; // 导出excel 的标题
            const filterVal = [
              'roomName',
              'feeSortName',
              'billcycleNo',
              'householdName',
              'payTime',
              'shouldAmount',
              'delayAmount',
              'accountpayAmount',
              'derateAmount',
              'payAmount',
              'payType',
              'cashierName',
              'invoiceNo',
              'payRemark',
            ]; // 每个标题对应的字段

            const list = (data || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                roomName: item.roomName,
                feeSortName: item.feeSortName,
                billcycleNo: item.billcycleNo,
                householdName: item.householdName,
                payTime: this.dayjs(item.payTime).format('YYYY-MM-DD HH:mm:ss'),
                shouldAmount: item.shouldAmount,
                delayAmount: item.delayAmount,
                accountpayAmount: item.accountpayAmount,
                derateAmount: item.derateAmount,
                payAmount: item.payAmount,
                payType: this.payTypeToPayTypeName(item.payType),
                cashierName: item.cashierName,
                tradeFee: item.tradeFee,
                invoiceNo: item.invoiceNo,
                payRemark: item.payRemark,
              };
            });
            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename: '收费费项明细' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            } else {
              this.$message.error('暂无有效数据');
            }
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    payTypeToPayTypeName(payType) {
      var payTypeName = '';
      this.allPayTypeList.forEach(function (value, index, array) {
        if (value.dictKey == payType) {
          payTypeName = value.dictValue;
          return;
        }
      });
      return payTypeName;
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 5px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: red;
}
</style>
